/* eslint @typescript-eslint/strict-boolean-expressions: off */

import React from "react";
import styles from "src/components/parameters/parameters.module.css";
import { TooltipInteractive } from "src/components/ui-components/Tooltip/TooltipInteractive";
import { Parameter, ParameterMerge } from "src/utils/parameters/types";
import { ParameterDialogButton } from "src/components/parameters/dialog";
import { InlineParameterField } from "./InlineParameterField";
import { findParameter, uniqueParam } from "src/utils/parameters/parameters";
import { preventDefault } from "src/utils/events/events";
import * as Menu from "src/components/ui-components/MenuPanel/MenuPanel";

interface Props {
  parameters: Parameter[];
  overrides: Parameter[];
  applied: Parameter[];
  onOverride?: (parameter: Parameter) => void;
  onApply?: () => void;
  onRemove?: (parameter: Parameter) => void;
  onReplace?: (index: number, parameter: Parameter) => void;
  disabled?: boolean;
  canEdit?: boolean;
}

// Used on query page
export const Parameters: React.FC<Props> = (props) => {
  if (props.parameters.length === 0) {
    return null;
  }

  const onKeyDown = (event: React.KeyboardEvent) => {
    if (document.activeElement === event.target && event.key === "Enter") {
      props.onApply?.();
    }
  };

  return (
    <form onSubmit={preventDefault} className={styles.parameters}>
      {props.parameters.map((p, i) => (
        <InlineParameterField
          key={uniqueParam(p)}
          pageType="query"
          parameter={p}
          override={findParameter(props.overrides, uniqueParam(p))}
          onChange={props.onOverride}
          onKeyDown={onKeyDown}
          onApply={props.onApply}
          disabled={props.disabled}
          editParameterButton={
            props.onReplace && (
              <ParameterDialogButton
                {...props}
                parameter={p}
                onReplace={props.onReplace.bind(null, i)}
              />
            )
          }
        />
      ))}
    </form>
  );
};

// Used on dashboard page
export const Param: React.FC<{
  parameter: Parameter;
  parameters: ParameterMerge;
  onApply?: () => void;
  openRunModal?: () => void;
  disabled?: boolean;
  canEdit?: boolean;
}> = (props) => {
  const onKeyDown = (event: React.KeyboardEvent) => {
    if (document.activeElement === event.target && event.key === "Enter") {
      props.onApply?.();
      // `setTimeout(fn, 0)`: Open the modal after the Enter click is
      // done propagating, otherwise the modal closes immediately.
      props.openRunModal && setTimeout(props.openRunModal, 0);
    }
  };

  return (
    <TooltipInteractive
      position="above-center"
      openOn="focus"
      content={() => (
        <>
          Hit <Menu.Shortcut shortcut="enter" /> to run
        </>
      )}
      renderInPortal
    >
      <div>
        <InlineParameterField
          pageType="dashboard"
          parameter={props.parameter}
          override={findParameter(
            props.parameters.state.overrides,
            uniqueParam(props.parameter)
          )}
          onChange={props.parameters.state.onOverride}
          onKeyDown={onKeyDown}
          onApply={props.onApply}
          disabled={props.disabled}
          hasFocusTooltip
        />
      </div>
    </TooltipInteractive>
  );
};
